import { IConfig } from './IConfig'

export const configProduction: IConfig = {
  api: {
    url: 'https://fb-ig-booking-app.blvd.co'
  }
}
